import { formatUtcDateForParam } from "../shared/date.js"

function gueltigesStartdatumUtcMs({ zeitpunktUtcMs, kreditstartUtcMs }) {
	if (kreditstartUtcMs == null || kreditstartUtcMs === 0) return zeitpunktUtcMs

	return Math.max(zeitpunktUtcMs, kreditstartUtcMs)
}

function buildNeueSondertilgungUrl({ zeitpunktUtcMs, kreditstartUtcMs, kreditId }) {
	const startdatum = formatUtcDateForParam(gueltigesStartdatumUtcMs({ zeitpunktUtcMs, kreditstartUtcMs }))
	const params = new URLSearchParams({
		"kredit_sondertilgung[startdatum]": startdatum,
	})

	return `/kredits/${encodeURIComponent(String(kreditId))}/sondertilgungs/new?${params.toString()}`
}

export function openNeueSondertilgung({ zeitpunktUtcMs, kreditstartUtcMs, kreditId, visit, frameId = "modal_neu" }) {
	const url = buildNeueSondertilgungUrl({ zeitpunktUtcMs, kreditstartUtcMs, kreditId })

	if (frameId) {
		visit(url, { frame: frameId })
		return
	}

	visit(url)
}
